/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

export class ScheduleItem {

  static readonly TIME_TYPE_AUTO = 0;
  static readonly TIME_TYPE_FIXED_START = 1;
  static readonly TIME_TYPE_FIXED_END = 2;
  static readonly TIME_TYPE_AUTO_PLAYED = 3;

  static readonly ENTRY_TYPE_ROUTINE: number = 1;
  static readonly ENTRY_TYPE_OPENING: number = 2;
  static readonly ENTRY_TYPE_FOOD: number = 3;
  static readonly ENTRY_TYPE_RESTROOM: number = 4;
  static readonly ENTRY_TYPE_JUDGES_BREAK: number = 5;
  static readonly ENTRY_TYPE_AWARDS: number = 6;
  static readonly ENTRY_TYPE_ANNOUNCEMENT: number = 7;

  static readonly ENTRY_STATUS_PLANNING: number = 0;
  static readonly ENTRY_STATUS_CONFIRMED: number = 1;
  static readonly ENTRY_STATUS_ACTIVE: number = 2;
  static readonly ENTRY_STATUS_COMPLETE: number = 3;
  static readonly ENTRY_STATUS_ON_HOLD: number = 4;
  static readonly ENTRY_STATUS_CANCELLED: number = 5;

  static readonly ENTRY_TIME_FORMAT: string = 'HH:mm:ss';
  static readonly ENTRY_DATE_FORMAT: string = 'YYYY-MM-DD';

  public formattedTime: string;

  constructor(public id: string,
              public timestamp: number,
              public routineType: number,
              public entryStatus: number,
              public date: string,
              public timeSlot: string,
              public duration: number,
              public sequence: number,
              public title: string,
              public description: string,
              public fixedType: number = ScheduleItem.TIME_TYPE_AUTO) {

  }

}



// WEBPACK FOOTER //
// ./src/models/schedule/ScheduleItem.ts